var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.75L4.89514 10.2231C4.41114 10.8685 3.40155 10.7046 3.14646 9.93937L2.25 7.25L1.26765 6.75882C0.49182 6.37091 0.543994 5.24678 1.35242 4.93239L10.9486 1.20053C11.7048 0.90645 12.478 1.58792 12.2812 2.37507L10.1784 10.7865C9.98984 11.5406 9.05074 11.8007 8.50111 11.2511L5.95711 8.70711C5.56658 8.31658 5.56658 7.68342 5.95711 7.29289L8.25 5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBadge);
export default __webpack_public_path__ + "static/media/telegram_badge.ba20fa727cc8b01f63650823422b3c82.svg";
export { ForwardRef as ReactComponent };